import { Dispatch } from "redux";
import { fetchMyData } from "services/auth.service";
import { User } from "models";

export enum LoginActions {
  LoginIsLoggingIn = "login/is_logging_in",
  LoginSuccessful = "login/login_successful",
  LoginFailed = "login/login_failed",
  Logout = "login/logout",
}

export interface LoginSuccessfulAction {
  type: LoginActions.LoginSuccessful;
  payload: User;
}

export interface LoginFailedAction {
  type: LoginActions.LoginFailed;
  payload: string;
}

export const loginSuccessful = (userInfo: User): LoginSuccessfulAction => {
  return {
    type: LoginActions.LoginSuccessful,
    payload: userInfo,
  };
};

export const loginFailed = (errorMessage: string): LoginFailedAction => {
  return {
    type: LoginActions.LoginFailed,
    payload: errorMessage,
  };
};

export const isLoggingIn = (flag: boolean) => {
  return {
    type: LoginActions.LoginIsLoggingIn,
    payload: flag,
  };
};

export const logOut = () => {
  sessionStorage.removeItem("cfdui_a_token");
  sessionStorage.removeItem("cfdui_r_token");

  return {
    type: LoginActions.Logout,
  };
};

export const requestLogin = (token: string, refreshToken: string) => {
  if (token && refreshToken) {
    sessionStorage.setItem("cfdui_id_token", token);
    sessionStorage.setItem("cfdui_refresh_token", refreshToken);
  }

  return async (dispatch: Dispatch) => {
    dispatch(isLoggingIn(true));

    return fetchMyData()
      .then((json) => {
        if (json) {
          dispatch(loginSuccessful(json as User));
        }
      })
      .catch((error) => {
        console.error(error);
        dispatch(loginFailed(error.message));
      });
  };
};
